import { roles } from '@nxsys/store/constants';
import OnHoldWorkerReport from '../../../modules/reports/onHoldWorker/listing/OnHoldWorkerReport';

export const onHoldWorkerReportsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/on-hold-worker',
    element: <OnHoldWorkerReport />,
  },
];
